import { PageHeader } from "@shared/components/PageHeader";
import React from "react";
import ChannelList from "../list/list";

const ChannelCommunicationLanding = ({ workflowDetail }: { workflowDetail: any }) => {
  return (
    <div>
      <div>
        <PageHeader
          title="Communication Channels"
          subtitle="View and manage execution history for this workflow"
        />
      </div>
      <div className="mt-4">
        <ChannelList workflowDetail={workflowDetail} />
      </div>
    </div>
  );
};

export default ChannelCommunicationLanding;
